import React from 'react'
import { conditionalClassList } from 'services/styles'
import useStyles from './styles'

export interface IBoxProps {
  children?: React.ReactNode
  style?: React.CSSProperties
  className?: string
  variant?: 'default' | 'wide' | 'compact'
  disableTopPadding?: boolean
  disableBottomPadding?: boolean
  disableLeftPadding?: boolean
  disableRightPadding?: boolean
}

const Box = (props: IBoxProps) => {
  const { classes } = useStyles()
  const { children, className, variant, disableBottomPadding, disableTopPadding, disableLeftPadding, disableRightPadding, ...restProps } = props

  const classListOptions = {
    [classes.box]: true,
    [classes.noPadTop]: disableTopPadding || false,
    [classes.noPadBottom]: disableBottomPadding || false,
    [classes.noPadLeft]: disableLeftPadding || false,
    [classes.noPadRight]: disableRightPadding || false,
  }

  if (variant) classListOptions[variant] = Boolean(variant)
  if (className) classListOptions[className] = true

  return (
    <div
      className={conditionalClassList(classListOptions)}
      {...restProps}
    >
      {children}
    </div>
  )
}

export default Box
